define('GameDayCore/GDModel/ValueObjects/Bench/BenchBatter',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(BenchBatter);

	function BenchBatter($data, $team) {
		var vo = VO.ensureVO(this, BenchBatter),
			data = $data;

		vo.id = data.id || "";
		vo.last = data.last || "";
		vo.team = $team;
		vo.b = data.b || "";
		vo.pos = data.pos || "";
		vo.avg = data.avg || "";
		vo.g = data.g || "";
		vo.ab = data.ab || "";
		vo.r = data.r || "";
		vo.h = data.h || "";
		vo.hr = data.hr || "";
		vo.rbi = data.rbi || "";
		vo.sb = data.sb || "";
	}

	return BenchBatter;
});
